import styled from 'styled-components';
import { SelectInput } from '@thinknet-gmbh/platform-common-ui';

interface IProps {
  itemWidth?: number;
}

export const StyledAutocompleteSelect = styled(SelectInput)<IProps>`
  .ant-select {
    ${({ itemWidth }: { itemWidth?: number }) =>
      itemWidth ? `width: ${itemWidth}px;` : `width: 288px;`};
  }
  .ant-select-arrow {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    div {
      margin: 0;
      color: ${({ theme }) => theme.colors.grayVariations.dark};
    }
  }
`;
